import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional className helper used by every shared-ui component.
 * `cn('base', cond && 'extra', { 'is-active': active })`
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
